import React, {useCallback, useEffect, useMemo} from 'react'
import * as css from './css/modifyAddress.module.scss'
import {observer, inject} from 'mobx-react'
import Back from 'components/common/back/Back'
import * as antdMobile from 'antd-mobile';
import * as antd from 'antd';
import * as api from '@/utils/api/api';
import {reaction} from "mobx";
import {useHistory, useParams} from 'react-router-dom';

const AddAddress = ({modifyAddress: store}) => {
    const [form] = antd.Form.useForm()

    const history = useHistory();
    const params = useParams();
    const id = Number(params.id);

    const fetchInfo = useCallback(() => {
        if (!id) {
            return;
        }

        api.addressInfo({id}).then(info => {
            const {
                name, telNumber, province, city, district, detailInfo, isDefault
            } = info;

            store.isDefault = isDefault;

            const provinceId = store.provinceList.find(item => item.name === province)?.id;
            const cityId = store.cityList.find(item => item.name === city)?.id;
            const districtId = store.districtList.find(item => item.name === district)?.id;

            store.currentProvinceId = provinceId;
            store.currentCityId = cityId;
            store.currentDistrictId = districtId;

            store.provinceId = provinceId;
            store.cityId = cityId;
            store.districtId = districtId;

            form.setFieldsValue({
                name, telNumber, detailInfo
            })
        })

    }, [id])

    const fetchProvinceList = useCallback(() => {
        api.areaList({parentId: -1}).then(list => {
            store.provinceList = list;
        })
    }, [])
    reaction(() => store.currentProvinceId, currentProvinceId => {
        if (currentProvinceId) {
            api.areaList({parentId: currentProvinceId}).then(list => {
                store.cityList = list;
            })
        }
    })
    reaction(() => store.currentCityId, currentCityId => {
        if (currentCityId) {
            api.areaList({parentId: currentCityId}).then(list => {
                store.districtList = list;
            })
        }
    })

    const addressData = useMemo(() => {
        let cityList = store.cityList.map(item => ({value: item.id, label: item.name}));

        if (store.currentCityId) {
            cityList = cityList.map(item => {
                if (store.currentCityId === item.value) {
                    item.children = store.districtList.map(item => ({value: item.id, label: item.name}));
                }

                return item;
            });
        }

        let provinceList = store.provinceList.map(item => ({value: item.id, label: item.name}));

        if (store.currentProvinceId) {
            provinceList = provinceList.map(item => {
                if (store.currentProvinceId === item.value) {
                    item.children = cityList;
                }

                return item;
            });
        }

        return provinceList;
    }, [store.provinceList, store.cityList, store.districtList]);

    useEffect(() => {
        fetchProvinceList();
    }, [fetchProvinceList]);
    useEffect(() => {
        fetchInfo();
    }, [fetchInfo])

    const onPickerChange = ([provinceId, cityId, districtId]) => {
        if (provinceId) {
            store.currentProvinceId = provinceId;
        }

        if (cityId) {
            store.currentCityId = cityId;
        }

        if (districtId) {
            store.currentDistrictId = districtId;
        }
    }

    const ongSelectAddress = ([provinceId, cityId, districtId]) => {
        if (provinceId) {
            store.provinceId = provinceId
        }

        if (cityId) {
            store.cityId = provinceId
        }

        if (districtId) {
            store.districtId = districtId
        }
    }
    const onSelectAddressCancel = () => {
        store.currentProvinceId = store.provinceId;
        store.currentCityId = store.cityId;
        store.currentDistrictId = store.districtId;
    }

    const defaultButton = useMemo(() => {
        let text = "设为默认";

        if (store.isDefault) {
            text = "取消默认";
        }

        const toggleIsDefault = () => {
            store.isDefault = !store.isDefault;
        }

        return <button className="is-default-btn" onClick={toggleIsDefault}>{text}</button>
    }, [store.isDefault])

    const onFinish = (values) => {
        const {addressField, detailInfo, name, telNumber} = values;
        const [provinceId, cityId, districtId] = addressField;

        const province = store.provinceList.find(item => item.id === provinceId)?.name;
        const city = store.cityList.find(item => item.id === cityId)?.name;
        const district = store.districtList.find(item => item.id === districtId)?.name;
        const {isDefault} = store;

        api.modifyAddress({id, name, telNumber, province, city, district, detailInfo, isDefault}).then(() => {
            antd.message.success("添加成功");
            history.goBack();
        });
    }

    const formInitialValues = {
        name: '',
        telNumber:'',
        addressField:[store.currentProvinceId, store.currentCityId, store.currentDistrictId]
    }

    return (
        <div className={css.addAddress}>
            <Back className=''>
                <div className=''>新建地址</div>
            </Back>
            <antd.Form className={css.form} onFinish={onFinish}>
                <antdMobile.List>
                    <antd.Form.Item className={css.formItem}>
                        <antd.Form.Item noStyle name={'name'}>
                            <antdMobile.InputItem
                                clear
                                placeholder='请输入收货人姓名'
                            >
                                收货人
                            </antdMobile.InputItem>
                        </antd.Form.Item>
                    </antd.Form.Item>
                    <antd.Form.Item className={css.formItem}>
                        <antd.Form.Item noStyle name='telNumber'>
                            <antdMobile.InputItem
                                clear
                                placeholder='请输入收货人手机号码'
                            >
                                手机号码
                            </antdMobile.InputItem>
                        </antd.Form.Item>
                    </antd.Form.Item>
                    <antd.Form.Item className={css.formItem}>
                        <antd.Form.Item noStyle name={'addressField'}>
                            {/*todo 1 ongSelectAddress onPickerChange onSelectAddressCancel */}
                            <antdMobile.Picker extra="请选择省市区"
                                               data={addressData}
                                               title="地址"
                                               onOk={ongSelectAddress}
                                               onChange={onPickerChange}
                                               onPickerChange={onPickerChange}
                                               onDismiss={onSelectAddressCancel}
                            >
                                <antdMobile.List.Item arrow="horizontal">省市区</antdMobile.List.Item>
                            </antdMobile.Picker>
                        </antd.Form.Item>
                    </antd.Form.Item>
                    <antd.Form.Item className={css.formItem}>
                        <antd.Form.Item noStyle name={'detailInfo'}>
                            <antdMobile.TextareaItem
                                clear
                                title='详细地址'
                                placeholder="请输入详细地址"
                                rows={3}
                            />
                        </antd.Form.Item>
                    </antd.Form.Item>
                    <antdMobile.List.Item extra={defaultButton}>
                        设置为默认地址
                        <antdMobile.List.Item.Brief>每次下单会默认使用改地址</antdMobile.List.Item.Brief>
                    </antdMobile.List.Item>
                </antdMobile.List>
                <antd.Form.Item noStyle>
                    <div className="btn-floor">
                        <button type='submit' className="submit">保存地址</button>
                    </div>
                </antd.Form.Item>
            </antd.Form>
        </div>
    )
}

export default inject('modifyAddress')(observer(AddAddress))
